(function () {
    'use strict';

    var module = angular.module('uwAgenda.help');
    module.factory('Help', [HelpFn]);

    function HelpFn() {

        var Help = function () {
            // default values
            this.caption = null;
            this.content = null;
            

        };

        // extend
        Help.prototype.extend = function (object) {
            var self = this;
            angular.extend(self, object);
        };

        return Help;


    }
})();